import News from "./news/main.es6";

const news = new News();
